import * as ApiHelper from "~/common/utils/ApiHelper";
import type { AddToCartApiItem, AddToCartResponseItem } from "~/features/cart/cart/api/AddToCart";
import { resolveApiUrl } from "~/utils/url/urlResolver";

interface QuoteToCart {
  quoteNumber: string;
  items: AddToCartApiItem[];
}

const apiUrl = resolveApiUrl("/quote/checkout");

interface QuoteToCartResponse {
  ok: boolean;
  responseItems: AddToCartResponseItem[];
}

export function sendData(data: QuoteToCart): Promise<QuoteToCartResponse> {
  const packageToCartForm = JSON.stringify(data);

  return fetch(apiUrl, {
    body: packageToCartForm,
    cache: "no-cache",
    credentials: "same-origin",
    method: "POST",
    mode: "cors",
    headers: {
      dataType: "json",
      "content-type": "application/json",
      CSRFToken: ApiHelper.getCsrfValue(),
    },
    redirect: "follow",
  }).then(async (result) => {
    window.SCHA.updateMinicart?.();
    return {
      ok: result.ok,
      responseItems: result.ok ? ((await result.json()) as AddToCartResponseItem[]) : [],
    };
  });
}
